{
  "name": "@tscircuit/schematic-viewer",
  "version": "2.0.95",
  "repository": {
    "type": "git",
    "url": "https://github.com/tscircuit/schematic-viewer"
  },
  "main": "dist/index.js",
  "type": "module",
  "scripts": {
    "start": "cosmos",
    "build": "tsup-node ./lib/index.ts --dts --format esm --sourcemap",
    "build:site": "cosmos-export",
    "vercel-build": "bun run build:site",
    "format": "biome format --write .",
    "format:check": "biome format ."
  },
  "files": [
    "dist"
  ],
  "devDependencies": {
    "@biomejs/biome": "^1.9.4",
    "@types/bun": "latest",
    "@types/debug": "^4.1.12",
    "@types/jsdom": "^21.1.7",
    "@types/react": "^19.0.1",
    "@types/react-dom": "^19.0.2",
    "@vitejs/plugin-react": "^4.3.4",
    "jsdom": "^26.0.0",
    "react": "^19.1.0",
    "react-cosmos": "^6.2.1",
    "react-cosmos-plugin-vite": "^6.2.0",
    "react-dom": "^19.1.0",
    "react-reconciler": "^0.31.0",
    "semver": "^7.7.2",
    "tscircuit": "^0.0.2460",
    "tsup": "^8.3.5",
    "vite": "^6.0.3",
    "@tscircuit/circuit-json-schematic-placement-analysis": "https://jscdn.tscircuit.com/@tscircuit/circuit-json-schematic-placement-analysis/0.0.11.tgz"
  },
  "peerDependencies": {
    "typescript": "^5.0.0",
    "tscircuit": "*"
  },
  "dependencies": {
    "@radix-ui/react-dialog": "^1.1.23",
    "@radix-ui/react-dropdown-menu": "^2.1.16",
    "@tscircuit/circuit-json-util": "^0.0.108",
    "circuit-json": "^0.0.479",
    "circuit-to-svg": "^0.0.421",
    "debug": "^4.4.0",
    "fflate": "^0.8.3",
    "performance-now": "^2.1.0",
    "use-mouse-matrix-transform": "^1.2.2"
  }
}
